import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { CourseOption } from '../../course-prerequisites/course-prerequisites.component';

/**
 * Hosts the existing `app-course-prerequisites` card in a dialog.
 *
 * Deliberately a wrapper and not a second implementation: the same links are
 * managed from the curriculum tree and from the Moodle overview, and two
 * copies of a two-sided approval flow would drift. The wrapper only supplies
 * the frame — see `participant-detail-dialog` for the same pattern.
 */
@Component({
  selector: 'app-course-prerequisites-dialog',
  templateUrl: './course-prerequisites-dialog.component.html',
  styleUrl: './course-prerequisites-dialog.component.scss',
})
export class CoursePrerequisitesDialogComponent {
  @Input() courseId!: string;
  @Input() courseName = '';
  /** Die Auswahl fuer neue Verknuepfungen. `hasResponsible` traegt die
   *  Moodle-Uebersicht mit; ohne den Wert gilt ein Kurs als waehlbar. */
  @Input() courses: CourseOption[] = [];
  @Input() canRequest = false;

  constructor(protected dialogRef: NbDialogRef<CoursePrerequisitesDialogComponent>) {}
}
